import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';

import { id } from '../../../utils/helper';

import styles from './styles';

const NO_IMAGE = 'https://s3.amazonaws.com/assets.staza.io/noimage.png';

// @Radium
class ImageUpload extends Component {
  static propTypes = {
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
    onUpload: PropTypes.func,
  };

  state = {
    imagePreviewUrl: '',
  }

  imageContainerStyle = {
    height: this.props.height || 150,
    width: this.props.width || 150,
  };

  handleUpload = () => {
    this.fileUpload.click();
  };

  handleOpacity = () => {
    document.getElementById('image').style.opacity = 0.2;
  };

  render() {
    const handleImageChange = (e) => {
      e.preventDefault();

      const reader = new FileReader();
      const file = e.target.files[0];
      if (!file) {
        return null;
      }
      const fileExtension = file.name.split('.').pop();
      const filename = `${id()}.${fileExtension}`;
      console.log('filename ============>', filename);
      //TODO review
      // if (this.props.type === 'employee') {
      //   FireBaseTools.uploadEmployeeImage(filename, file);
      // } else if (this.props.type === 'customer') {
      //   FireBaseTools.uploadCustomerImage(filename, file);
      // }
      reader.onloadend = () => {
        this.setState({
          file,
          imagePreviewUrl: reader.result,
        });
        document.getElementById('image').style.opacity = 1;
        this.props.onUpload(filename, file);
      };

      reader.readAsDataURL(file);
    };

    let src = this.state.imagePreviewUrl ? this.state.imagePreviewUrl : this.props.src;
    if (!src) {
      src = NO_IMAGE;
    }

    return (
      <div
        style={styles.container}
        onMouseEnter={() => this.setState({ uploadVisible: true })}
        onMouseLeave={() => this.setState({ uploadVisible: false })}
        onClick={() => this.handleUpload()}
      >

        {this.state.uploadVisible ? <IconButton
          iconClassName="material-icons"
          style={styles.upload}
          onMouseOver={this.handleOpacity}
        >
          file_upload
        </IconButton> : null }
        <div style={this.imageContainerStyle}>
          <img alt="Preview" id="image" src={src} style={styles.image}/>
        </div>

        <input
          type="file"
          ref={(fileUpload) => this.fileUpload = fileUpload}
          onChange={handleImageChange}
          style={styles.fileInput}/>
      </div>
    );
  }
}

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/Common/ImageUpload/index.js